import { Grid, List, ListItemButton, ListItemIcon, TextField, Typography, Paper, Button } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import type { AddressSuggestion, IErrors } from "./types";
import { useAddressSearch } from "./hooks";
import { useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import { english_regex_spec_char } from "../../constants";
import { AcctionButtons } from "../CompletionPage/AcctionButtons";

interface IAddressSearch {
  errors: IErrors;
  setErrors(erros: IErrors): void;
  validateAddress(input: string): void;
  pickSuggestion(sug: AddressSuggestion): void;
  setLocalError(msg: string | null): void;
  loaclError: string | null;
  setSuggestions(suggestions: AddressSuggestion[]): void;
  suggestions: AddressSuggestion[];
  handleClose(): void;
}

export function AddressSearch(props: IAddressSearch) {
  const {
    errors,
    setErrors,
    pickSuggestion,
    validateAddress,
    setLocalError,
    loaclError,
    setSuggestions,
    suggestions,
    handleClose,
  } = props;
  const { addressInput, setAddressinput } = useAddressSearch();
  const text = useAppSelector(selectText);
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const setError = (key: string, err: boolean, msg: string) => {
    const _errors = { ...errors };
    const error = { err, msg };
    _errors[key] = error;
    setErrors(_errors);
  };

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={3} sx={{ padding: 0 }}>
      <Grid item xs={12} xl={12} sx={{}}>
        <TextField
          variant="outlined"
          name="address_input"
          id="address_input"
          sx={{ direction: "ltr" }}
          fullWidth
          helperText={errors.address_input?.err ? errors.address_input.msg : ""}
          label={text.addres_english_only}
          error={errors.address_input?.err ? true : false}
          onChange={(e) => {
            setErrors({});
            setSuggestions([]);
            if (!english_regex_spec_char.test(e.target.value)) {
              setError("address_input", true, text.only_english);
              return;
            }
            setAddressinput(e.target.value);
            setLocalError(null);
          }}
          onBlur={() => {}}
          value={addressInput}
          onKeyDown={handleKeyDown}
        />
      </Grid>
      <Grid item xs={12} xl={12}>
        {!suggestions.length ? (
          <AcctionButtons
            type="button"
            action={() => validateAddress(addressInput)}
            handleClose={handleClose}
            title={text.find_address}
          />
        ) : (
          <Button
            variant={"contained"}
            onClick={() => validateAddress(addressInput)}
            type="button"
            sx={{ width: "100%" }}
            fullWidth
          >
            {text.find_address}
          </Button>
        )}
      </Grid>
      <Grid item xs={12} xl={12} sx={{}}>
        <Typography textAlign={"center"} sx={{ color: "red" }}>
          {loaclError}
        </Typography>
      </Grid>
      {suggestions.length ? (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{}}>
          <Paper sx={{ marginBottom: 10 }}>
            <Typography textAlign={"center"}>
              <b>{text.select_address} </b>
            </Typography>
            <List>
              {suggestions.map((suggest, i) => (
                <ListItemButton
                  id={"suggestion" + i}
                  key={i}
                  onClick={() => {
                    pickSuggestion(suggest);
                  }}
                >
                  <ListItemIcon>
                    <PlaceIcon />
                  </ListItemIcon>

                  <Typography key={suggest.place_id}>{suggest.description}</Typography>
                </ListItemButton>
              ))}
            </List>
          </Paper>
        </Grid>
      ) : null}
    </Grid>
  );
}
